import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

declare global {
  interface Window {
    OnetrustActiveGroups?: string;
    loadGTM?: () => void;
  }
}

const ScriptInjector = () => {
  useEffect(() => {
    const script = document.createElement('script');

    if (ONETRUST_KEY) {
      script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
      script.async = true;
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('charset', 'UTF-8');
      script.setAttribute('data-domain-script', ONETRUST_KEY ?? '');
      document.body.appendChild(script);
      console.log('%c%s', 'color: green;', 'ONETRUST SCRIPT LOAD');
    }

    return () => {
      if (ONETRUST_KEY) {
        document.body.removeChild(script);
      }
    };
  }, []);

  if (!ONETRUST_KEY) return null

  return (
    <Helmet>
      <script type="text/javascript">
        {`
          function OptanonWrapper() {
            // Esta función es llamada por OneTrust cuando:
            // 1. El banner se carga
            // 2. El usuario acepta/rechaza cookies
            // 3. El usuario cambia sus preferencias

            console.log('%c%s', 'color: blue;', 'OptanonWrapper called');
            console.log('Active groups:', window.OnetrustActiveGroups);

            // Verificar si el usuario aceptó cookies de Performance o Targeting
            // C0002 = Performance Cookies (Analytics)
            // C0004 = Targeting Cookies (Marketing/Advertising)
            const activeGroups = window.OnetrustActiveGroups || '';
            const hasPerformanceCookies = activeGroups.includes('C0002');
            const hasTargetingCookies = activeGroups.includes('C0004');

            // Si aceptó cookies de analytics o marketing, cargar GTM
            if (hasPerformanceCookies || hasTargetingCookies) {
              console.log('%c%s', 'color: green;', 'Consent granted for analytics/marketing - Loading GTM');
              if (window.loadGTM) {
                window.loadGTM();
              }
            } else {
              console.log('%c%s', 'color: orange;', 'No consent for analytics/marketing - GTM blocked');
            }
          }
        `}
      </script>
    </Helmet>
  )
};

export default ScriptInjector;